import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
	from {
		opacity: 0;
	}
	to {
		opacity: 1;
	}
`;

export const BettoAlertOverlay = styled.div`
	position: fixed;
	inset: 0;
	z-index: 1300;
	display: flex;
	align-items: flex-start;
	justify-content: center;
	padding: 48px 16px 20px;
	overflow-y: auto;
	background: var(--bt-auth-overlay-bg, rgba(10, 14, 26, 0.94));
	backdrop-filter: blur(12.5px);
	animation: ${fadeIn} 0.3s ease-in forwards;

	@media (min-width: 1024px) {
		align-items: center;
		padding: 20px 16px;
	}

	@media (max-width: 767px) {
		padding: 16px 12px;
		align-items: flex-start;
	}
`;

export const BettoAlertCard = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	width: min(400px, calc(100vw - 32px));
	max-width: 400px;
	max-height: min(640px, calc(100vh - 48px));
	height: auto;
	background: #171c2a;
	border: 1px solid #2b3245;
	border-radius: 20px;
	overflow: hidden;
`;

export const BettoAlertCloseButton = styled.button`
	position: absolute;
	top: 15px;
	right: 15px;
	z-index: 3;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 32px;
	height: 32px;
	padding: 8px;
	border: none;
	border-radius: 8px;
	background: #2b3245;
	color: #e5f0fe;
	cursor: pointer;

	svg {
		width: 16px;
		height: 16px;
	}
`;

export const BettoAlertIllustration = styled.div`
	position: relative;
	flex: 0 0 auto;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	min-height: 200px;
	padding: 8px 24px 0;
	box-sizing: border-box;
	overflow: hidden;
	background: #171c2a;

	img {
		display: block;
		width: min(354px, 100%);
		max-height: 240px;
		height: auto;
		object-fit: contain;
		object-position: center center;
	}
`;

export const BettoAlertContent = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 24px;
	flex: 1 1 auto;
	padding: 8px 23px 28px;
	overflow-y: auto;
`;

export const BettoAlertCopy = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 16px;
	width: 100%;
	text-align: center;
`;

export const BettoAlertTitle = styled.h2`
	margin: 0;
	width: 100%;
	color: #e5f0fe;
	font-size: 22px;
	font-weight: 600;
	line-height: 1.1;
	letter-spacing: -1.32px;
	text-transform: capitalize;
	word-break: break-word;
`;

export const BettoAlertMessage = styled.p`
	margin: 0;
	width: 100%;
	color: #a5b1c1;
	font-size: 14px;
	font-weight: 400;
	line-height: 1.4;
	letter-spacing: -0.42px;
	word-break: break-word;
`;

export const BettoAlertActions = styled.div`
	display: flex;
	gap: 12px;
	width: 100%;
`;

const buttonBase = `
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: 46px;
	padding: 12px 24px;
	border: none;
	border-radius: 10px;
	font-size: 16px;
	font-weight: 600;
	line-height: 1.4;
	letter-spacing: -0.48px;
	color: #e5f0fe;
	cursor: pointer;
	white-space: nowrap;
`;

export const BettoAlertPrimaryButton = styled.button`
	${buttonBase}
	flex: ${({ $fullWidth }) => ($fullWidth ? "1 1 100%" : "1 1 0")};
	width: ${({ $fullWidth }) => ($fullWidth ? "100%" : "auto")};
	background: #0362d4;
`;

export const BettoAlertSecondaryButton = styled.button`
	${buttonBase}
	flex: 1 1 0;
	background: #1f2536;
`;
